
// import React, { useState, useEffect, useRef } from "react";
// import { FaBuilding, FaHome, FaMapMarkerAlt, FaSpinner, FaTimes, FaUpload, FaUserCog } from "react-icons/fa";
// import { Apartment } from "../../hook/types/apartment";
// import { useProperties } from "../../hook/useProperties";
// import { Property } from "../../hook/types/property";
// import { useApartment } from "../../hook/useApartment";

// interface EditApartmentPopupProps {
//   apartment: Apartment;
//   onClose: () => void;
//   onSubmit: (formData: Apartment) => Promise<void>; // Changed back to Apartment type
//   onCancel: () => void;
//   isOpen: boolean;
//   id: string | number;
//   isLoading: boolean;
// }

// const EditApartmentPopup: React.FC<EditApartmentPopupProps> = ({
//   apartment,
//   onClose,
//   onSubmit,
//   onCancel,
//   isOpen,
//   id,
//   isLoading
// }) => {
//   const [formData, setFormData] = useState<Apartment>(apartment);
//   const [errors, setErrors] = useState<Partial<{ apartmentName: string; apartmentAddress: string; apartmentType: string }>>({});
//   const [imagePreview, setImagePreview] = useState<string | null>(
//     typeof apartment.apartmentImageUrl === 'string' && apartment.apartmentImageUrl 
//       ? apartment.apartmentImageUrl 
//       : null
//   );
//   const [selectedProperties, setSelectedProperties] = useState<Property[]>([]);
//   const [availableProperties, setAvailableProperties] = useState<Property[]>([]);
//   const [imageFile, setImageFile] = useState<File | null>(null);
  
//   const fileInputRef = useRef<HTMLInputElement>(null);
//   const { Property: fetchProperties } = useProperties();
//   const { getApartmentImageUrl } = useApartment();
//   const propertiesData = fetchProperties({ active: true, delete: false, page: 0, size: 1000 });

//   useEffect(() => {
//     const initializeFormData = async () => {
//       setFormData(apartment);
//       setErrors({});
      
//       // Handle image preview - FIXED
//       if (apartment.apartmentImageUrl && typeof apartment.apartmentImageUrl === 'string') {
//         try {
//           // If we have an apartment ID, try to get the image URL
//           if (apartment.id) {
//             const url = await getApartmentImageUrl(apartment.id.toString());
//             setImagePreview(url);
//           } else {
//             setImagePreview(apartment.apartmentImageUrl);
//           }
//         } catch (error) {
//           console.error("Error loading apartment image:", error);
//           setImagePreview(null);
//         }
//       } else {
//         setImagePreview(null);
//       }
      
//       setImageFile(null);
//     };

//     initializeFormData();
//   }, [apartment, getApartmentImageUrl]);

//   useEffect(() => {
//     if (propertiesData.data?.data) {
//       const allProps = [
//         ...(propertiesData.data.data.RESIDENTIAL || []),
//         ...(propertiesData.data.data.COMMERCIAL || [])
//       ];
//       setAvailableProperties(allProps);
      
//       // Set initially selected properties - FIXED COMPARISON
//       if (apartment.propertyHoldings && apartment.propertyHoldings.length > 0) {
//         const selected = allProps.filter(availableProp => 
//           // Check if this available property exists in the apartment's propertyHoldings
//           apartment.propertyHoldings.some(holding => 
//             // Compare IDs - holding could be an object with id property
//             availableProp.id?.toString() === (typeof holding === 'object' ? holding.id?.toString() : holding?.toString())
//           )
//         );
//         setSelectedProperties(selected);
//       }
//     }
//   }, [propertiesData.data, apartment.propertyHoldings]);

//   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const { name, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: checked
//     }));
//   };

//   const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       setImageFile(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setImagePreview(reader.result as string);
//         // Don't set apartmentImageUrl here - it should be handled by the backend
//       };
//       reader.readAsDataURL(file);
//     }
//   };

//   const handlePropertySelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     const selectedId = e.target.value;
//     if (!selectedId) return;
    
//     const property = availableProperties.find(p => p.id === parseInt(selectedId));
//     if (property && property.id && !selectedProperties.some(p => p.id === property.id)) {
//       setSelectedProperties(prev => [...prev, property]);
//       setFormData(prev => ({
//         ...prev,
//         propertyHoldings: [...prev.propertyHoldings, property.id as any]
//       }));
//     }
//     e.target.value = ""; // Reset the dropdown
//   };

//   const removeProperty = (propertyId: number) => {
//     setSelectedProperties(prev => prev.filter(p => p.id !== propertyId));
//     setFormData(prev => ({
//       ...prev,
//       propertyHoldings: prev.propertyHoldings.filter(id => id !== propertyId as any)
//     }));
//   };

//   const validateForm = (): boolean => {
//     const newErrors: Partial<{ apartmentName: string; apartmentAddress: string; apartmentType: string }> = {};
    
//     if (!formData.apartmentName?.trim()) {
//       newErrors.apartmentName = "Apartment name is required";
//     }
    
//     if (!formData.apartmentAddress?.trim()) {
//       newErrors.apartmentAddress = "Address is required";
//     }
    
//     if (!formData.appartmentType) {
//       newErrors.apartmentType = "Apartment type is required";
//     }
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
    
//     if (!validateForm()) return;
    
//     try {
//       // Prepare the data for submission
//       const submissionData: Apartment = {
//         ...formData,
//         propertyHoldings: selectedProperties.map(prop => prop.id as number).filter(id => id !== undefined),
//         apartmentImage: imageFile || undefined
//       };
      
//       await onSubmit(submissionData);
//     } catch (error) {
//       console.error("Error submitting form:", error);
//     }
//   };

//   const triggerFileInput = () => {
//     if (fileInputRef.current) {
//       fileInputRef.current.click();
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50 p-4">
//       <div className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
//         <div className="flex justify-between items-center p-6 border-b">
//           <h2 className="text-xl font-bold text-gray-800 flex items-center">
//             <FaHome className="text-primary mr-2" />
//             {id ? "Edit Apartment" : "Add New Apartment"}
//           </h2>
//           <button
//             onClick={onClose}
//             className="text-gray-500 hover:text-gray-700 transition-colors"
//             disabled={isLoading}
//           >
//             <FaTimes className="w-6 h-6" />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit} className="p-6">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            
//             {/* Left Column - Name, Type, Address, Image, Status */}
//             <div className="space-y-6">
//               {/* Apartment Name */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
//                   <FaHome className="text-blue-500 h-4 w-4 mr-2" /> Apartment Name *
//                 </label>
//                 <input
//                   type="text"
//                   name="apartmentName"
//                   value={formData.apartmentName || ""}
//                   onChange={handleInputChange}
//                   disabled={isLoading}
//                   className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
//                     errors.apartmentName ? 'border-red-500' : 'border-gray-300'
//                   }`}
//                   placeholder="Enter apartment name"
//                 />
//                 {errors.apartmentName && (
//                   <p className="text-red-500 text-sm mt-2">{errors.apartmentName}</p>
//                 )}
//               </div>

//               {/* Apartment Type */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
//                   <FaBuilding className="text-purple-500 h-4 w-4 mr-2" /> Apartment Type *
//                 </label>
//                 <select
//                   name="appartmentType"
//                   value={formData.appartmentType || ""}
//                   onChange={handleInputChange}
//                   disabled={isLoading}
//                   className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
//                     errors.apartmentType ? 'border-red-500' : 'border-gray-300'
//                   }`}
//                 >
//                   <option value="">Select apartment type</option>
//                   <option value="RESIDENTIAL">Residential</option>
//                   <option value="COMMERCIAL">Commercial</option>
//                 </select>
//                 {errors.apartmentType && (
//                   <p className="text-red-500 text-sm mt-2">{errors.apartmentType}</p>
//                 )}
//               </div>

//               {/* Address */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
//                   <FaMapMarkerAlt className="text-yellow-500 h-4 w-4 mr-2" /> Address *
//                 </label>
//                 <textarea
//                   name="apartmentAddress"
//                   value={formData.apartmentAddress || ""}
//                   onChange={handleInputChange}
//                   disabled={isLoading}
//                   rows={3}
//                   className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
//                     errors.apartmentAddress ? 'border-red-500' : 'border-gray-300'
//                   }`}
//                   placeholder="Enter full address"
//                 />
//                 {errors.apartmentAddress && (
//                   <p className="text-red-500 text-sm mt-2">{errors.apartmentAddress}</p>
//                 )}
//               </div>

//               {/* Image Upload */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center">
//                   <FaUpload className="text-red-500 h-4 w-4 mr-2" /> Apartment Image
//                 </label>
//                 <div className="flex flex-col items-center">
//                   {imagePreview && (
//                     <img
//                       src={imagePreview}
//                       alt="Apartment preview"
//                       className="w-full h-48 object-cover rounded-lg border mb-4"
//                     />
//                   )}
//                   <div 
//                     onClick={triggerFileInput}
//                     className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-primary transition-colors"
//                   >
//                     <FaUpload className="w-8 h-8 text-gray-400 mb-2" />
//                     <span className="text-sm text-gray-500 text-center">Click to upload or drag and drop</span>
//                     <input
//                       ref={fileInputRef}
//                       type="file"
//                       accept="image/*"
//                       onChange={handleImageChange}
//                       className="hidden"
//                       disabled={isLoading}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* Status Toggle */}
//               <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg">
//                 <div className="flex items-center">
//                   <label className="text-sm font-medium text-gray-700 flex items-center mr-3">
//                     <FaUserCog className="text-primary h-4 w-4 mr-2" /> Status:
//                   </label>
//                   <label className="relative inline-flex items-center cursor-pointer">
//                     <input
//                       type="checkbox"
//                       name="isActive"
//                       checked={formData.isActive || false}
//                       onChange={handleCheckboxChange}
//                       disabled={isLoading}
//                       className="sr-only peer"
//                     />
//                     <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
//                   </label>
//                 </div>
//                 <span className={`text-sm font-medium ${formData.isActive ? "text-green-600" : "text-gray-600"}`}>
//                   {formData.isActive ? "Active" : "Inactive"}
//                 </span>
//               </div>
//             </div>

//             {/* Right Column - Properties */}
//             <div className="space-y-6">
//               <div className="bg-gray-50 rounded-lg p-4 h-full">
//                 <h3 className="text-sm font-semibold mb-4 flex items-center">
//                   <FaBuilding className="text-purple-500 mr-2" /> Associated Properties
//                 </h3>
                
//                 {/* Properties Selection */}
//                 <div className="mb-4">
//                   <label className="block text-sm font-medium text-gray-700 mb-2">
//                     Add Properties
//                   </label>
//                   <select
//                     onChange={handlePropertySelect}
//                     disabled={isLoading}
//                     className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
//                     defaultValue=""
//                   >
//                     <option value="">Select a property to add</option>
//                     {availableProperties
//                       .filter(prop => prop.id && !selectedProperties.some(p => p.id === prop.id))
//                       .map((property: Property) => (
//                         <option key={property.id} value={property.id}>
//                           {property.propertyName} ({property.propertyType})
//                         </option>
//                       ))}
//                   </select>
//                 </div>

//                 {/* Selected Properties List */}
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-2">
//                     Selected Properties ({selectedProperties.length})
//                   </label>
//                   <div className="space-y-2 max-h-64 overflow-y-auto">
//                     {selectedProperties.length > 0 ? (
//                       selectedProperties.map((property) => (
//                         <div key={property.id} className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-200">
//                           <div>
//                             <span className="text-sm font-medium">
//                               {property.propertyName}
//                             </span>
//                             <span className="text-xs text-gray-500 ml-2">
//                               ({property.propertyType})
//                             </span>
//                           </div>
//                           <button
//                             type="button"
//                             onClick={() => property.id && removeProperty(property.id)}
//                             className="text-red-500 hover:text-red-700 text-sm"
//                             disabled={isLoading}
//                           >
//                             <FaTimes />
//                           </button>
//                         </div>
//                       ))
//                     ) : (
//                       <div className="text-center py-4 text-gray-500 text-sm">
//                         No properties selected
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Form Actions */}
//           <div className="flex justify-end space-x-4 pt-6 border-t mt-6">
//             <button
//               type="submit"
//               disabled={isLoading}
//               className="px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors disabled:opacity-50 flex items-center space-x-2 font-medium"
//             >
//               {isLoading && <FaSpinner className="animate-spin" />}
//               <span>{id ? "Update" : "Save"} </span>
//             </button>
//             <button
//               type="button"
//               onClick={onCancel}
//               disabled={isLoading}
//               className="bg-red-400 hover:bg-red-500 text-white px-6 py-3 border border-gray-300 rounded-lg transition-colors disabled:opacity-50 font-medium"
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EditApartmentPopup;


import React, { useState, useEffect, useRef, useCallback } from "react";
import { FaBuilding, FaHome, FaMapMarkerAlt, FaSpinner, FaTimes, FaUpload, FaUserCog } from "react-icons/fa";
import { Apartment } from "../../hook/types/apartment";
import { useProperties } from "../../hook/useProperties";
import { Property } from "../../hook/types/property";
import { useApartment } from "../../hook/useApartment";

interface EditApartmentPopupProps {
  apartment: Apartment;
  onClose: () => void;
  onSubmit: (formData: Apartment) => Promise<void>;
  onCancel: () => void;
  isOpen: boolean;
  id: string | number;
  isLoading: boolean;
}

const EditApartmentPopup: React.FC<EditApartmentPopupProps> = ({
  apartment,
  onClose,
  onSubmit,
  onCancel,
  isOpen,
  id,
  isLoading
}) => {
  const [formData, setFormData] = useState<Apartment>(apartment);
  const [errors, setErrors] = useState<Partial<{ apartmentName: string; apartmentAddress: string; apartmentType: string }>>({});
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [selectedProperties, setSelectedProperties] = useState<Property[]>([]);
  const [availableProperties, setAvailableProperties] = useState<Property[]>([]);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const [isImageLoading, setIsImageLoading] = useState(true);
  
  const fileInputRef = useRef<HTMLInputElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const { Property: fetchProperties } = useProperties();
  const { getApartmentImageUrl } = useApartment();
  const propertiesData = fetchProperties({ active: true, delete: false, page: 0, size: 1000 });

  // Stable initialization function
  const initializeFormData = useCallback(async () => {
    setFormData(apartment);
    setErrors({});
    setIsImageLoading(true);
    
    // Handle image preview
    if (apartment.apartmentImageUrl && typeof apartment.apartmentImageUrl === 'string') {
      try {
        if (apartment.id) {
          const url = await getApartmentImageUrl(apartment.id.toString());
          setImagePreview(url);
        } else {
          setImagePreview(apartment.apartmentImageUrl);
        }
      } catch (error) {
        console.error("Error loading apartment image:", error);
        setImagePreview(null);
      } finally {
        setIsImageLoading(false);
      }
    } else {
      setImagePreview(null);
      setIsImageLoading(false);
    }
    
    setImageFile(null);
  }, [apartment, getApartmentImageUrl]);

  useEffect(() => {
    if (isOpen) {
      initializeFormData();
    }
  }, [isOpen, initializeFormData]);

  useEffect(() => {
    if (propertiesData.data?.data) {
      const allProps = [
        ...(propertiesData.data.data.RESIDENTIAL || []),
        ...(propertiesData.data.data.COMMERCIAL || [])
      ];
      setAvailableProperties(allProps);
      
      // Set initially selected properties
      if (apartment.propertyHoldings && apartment.propertyHoldings.length > 0) {
        const selected = allProps.filter(availableProp => 
          apartment.propertyHoldings.some(holding => 
            availableProp.id?.toString() === (typeof holding === 'object' ? holding.id?.toString() : holding?.toString())
          )
        );
        setSelectedProperties(selected);
      }
    }
  }, [propertiesData.data, apartment.propertyHoldings]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setImageFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePropertySelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = e.target.value;
    if (!selectedId) return;
    
    const property = availableProperties.find(p => p.id === parseInt(selectedId));
    if (property && property.id && !selectedProperties.some(p => p.id === property.id)) {
      setSelectedProperties(prev => [...prev, property]);
      setFormData(prev => ({
        ...prev,
        propertyHoldings: [...prev.propertyHoldings, property.id as any]
      }));
    }
    e.target.value = ""; // Reset the dropdown
  };

  const removeProperty = (propertyId: number) => {
    setSelectedProperties(prev => prev.filter(p => p.id !== propertyId));
    setFormData(prev => ({
      ...prev,
      propertyHoldings: prev.propertyHoldings.filter(id => id !== propertyId as any)
    }));
  };

  const validateForm = (): boolean => {
    const newErrors: Partial<{ apartmentName: string; apartmentAddress: string; apartmentType: string }> = {};
    
    if (!formData.apartmentName?.trim()) {
      newErrors.apartmentName = "Apartment name is required";
    }
    
    if (!formData.apartmentAddress?.trim()) {
      newErrors.apartmentAddress = "Address is required";
    }
    
    if (!formData.appartmentType) {
      newErrors.apartmentType = "Apartment type is required";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    try {
      // Prepare the data for submission
      const submissionData: Apartment = {
        ...formData,
        propertyHoldings: selectedProperties.map(prop => prop.id as number).filter(id => id !== undefined),
        apartmentImage: imageFile || undefined
      };
      
      await onSubmit(submissionData);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex justify-center items-center z-50 p-4">
      <div 
        ref={popupRef}
        className="bg-white rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto"
        style={{ minHeight: '600px' }} // Set a minimum height to prevent resizing
      >
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-bold text-gray-800 flex items-center">
            <FaHome className="text-primary mr-2" />
            {id ? "Edit Apartment" : "Add New Apartment"}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
            disabled={isLoading}
          >
            <FaTimes className="w-6 h-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            
            {/* Left Column - Name, Type, Address, Image, Status */}
            <div className="space-y-6">
              {/* Apartment Name */}
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2 flex items-center">
                  <FaHome className="text-blue-500 h-4 w-4 mr-2" /> Apartment Name *
                </label>
                <input
                  type="text"
                  name="apartmentName"
                  value={formData.apartmentName || ""}
                  onChange={handleInputChange}
                  disabled={isLoading}
                  className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
                    errors.apartmentName ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="Enter apartment name"
                />
                {errors.apartmentName && (
                  <p className="text-red-500 text-sm mt-2">{errors.apartmentName}</p>
                )}
              </div>

              {/* Apartment Type */}
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2 flex items-center">
                  <FaBuilding className="text-purple-500 h-4 w-4 mr-2" /> Apartment Type *
                </label>
                <select
                  name="appartmentType"
                  value={formData.appartmentType || ""}
                  onChange={handleInputChange}
                  disabled={isLoading}
                  className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
                    errors.apartmentType ? 'border-red-500' : 'border-gray-300'
                  }`}
                >
                  <option value="">Select apartment type</option>
                  <option value="RESIDENTIAL">Residential</option>
                  <option value="COMMERCIAL">Commercial</option>
                </select>
                {errors.apartmentType && (
                  <p className="text-red-500 text-sm mt-2">{errors.apartmentType}</p>
                )}
              </div>

              {/* Address */}
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2 flex items-center">
                  <FaMapMarkerAlt className="text-yellow-500 h-4 w-4 mr-2" /> Address *
                </label>
                <textarea
                  name="apartmentAddress"
                  value={formData.apartmentAddress || ""}
                  onChange={handleInputChange}
                  disabled={isLoading}
                  rows={3}
                  className={`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary ${
                    errors.apartmentAddress ? 'border-red-500' : 'border-gray-300'
                  }`}
                  placeholder="Enter full address"
                />
                {errors.apartmentAddress && (
                  <p className="text-red-500 text-sm mt-2">{errors.apartmentAddress}</p>
                )}
              </div>

              {/* Image Upload */}
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2 flex items-center">
                  <FaUpload className="text-red-500 h-4 w-4 mr-2" /> Apartment Image
                </label>
                <div className="flex flex-col items-center">
                  {isImageLoading ? (
                    <div className="w-full h-48 flex items-center justify-center bg-gray-100 rounded-lg border mb-4">
                      <FaSpinner className="animate-spin text-gray-400 text-2xl" />
                    </div>
                  ) : imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="Apartment preview"
                      className="w-full h-48 object-cover rounded-lg border mb-4"
                      onLoad={() => setIsImageLoading(false)}
                      onError={() => {
                        setIsImageLoading(false);
                        setImagePreview(null);
                      }}
                    />
                  ) : (
                    <div className=" flex items-center justify-center ">
                      <span className="text-gray-500">No image available</span>
                    </div>
                  )}
                  <div 
                    onClick={triggerFileInput}
                    className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-primary transition-colors"
                  >
                    <FaUpload className="w-8 h-8 text-gray-400 mb-2" />
                    <span className="text-sm text-gray-500 text-center">Click to upload or drag and drop</span>
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept="image/*"
                      onChange={handleImageChange}
                      className="hidden"
                      disabled={isLoading}
                    />
                  </div>
                </div>
              </div>

              {/* Status Toggle */}
              <div className="flex items-center space-x-3 p-4 bg-gray-50 rounded-lg">
                <div className="flex items-center">
                  <label className="text-sm font-bold text-gray-700 flex items-center mr-3">
                    <FaUserCog className="text-primary h-4 w-4 mr-2" /> Status:
                  </label>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      name="isActive"
                      checked={formData.isActive || false}
                      onChange={handleCheckboxChange}
                      disabled={isLoading}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                  </label>
                </div>
                <span className={`text-sm font-medium ${formData.isActive ? "text-green-600" : "text-gray-600"}`}>
                  {formData.isActive ? "Active" : "Inactive"}
                </span>
              </div>
            </div>

            {/* Right Column - Properties */}
            <div className="space-y-6">
              <div className="bg-gray-50 rounded-lg p-4 h-full">
                <h3 className="text-sm font-semibold mb-4 flex items-center">
                  <FaBuilding className="text-purple-500 mr-2" /> Associated Properties
                </h3>
                
                {/* Properties Selection */}
                <div className="mb-4">
                  <label className="block text-sm font-bold text-gray-700 mb-2">
                    Add Properties
                  </label>
                  <select
                    onChange={handlePropertySelect}
                    disabled={isLoading}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    defaultValue=""
                  >
                    <option value="">Select a property to add</option>
                    {availableProperties
                      .filter(prop => prop.id && !selectedProperties.some(p => p.id === prop.id))
                      .map((property: Property) => (
                        <option key={property.id} value={property.id}>
                          {property.propertyName} ({property.propertyType})
                        </option>
                      ))}
                  </select>
                </div>

                {/* Selected Properties List */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Selected Properties ({selectedProperties.length})
                  </label>
                  <div className="space-y-2 max-h-64 overflow-y-auto">
                    {selectedProperties.length > 0 ? (
                      selectedProperties.map((property) => (
                        <div key={property.id} className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-200">
                          <div>
                            <span className="text-sm font-medium">
                              {property.propertyName}
                            </span>
                            <span className="text-xs text-gray-500 ml-2">
                              ({property.propertyType})
                            </span>
                          </div>
                          <button
                            type="button"
                            onClick={() => property.id && removeProperty(property.id)}
                            className="text-red-500 hover:text-red-700 text-sm"
                            disabled={isLoading}
                          >
                            <FaTimes />
                          </button>
                        </div>
                      ))
                    ) : (
                      <div className="text-center py-4 text-gray-500 text-sm">
                        No properties selected
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Form Actions */}
          <div className="flex justify-end space-x-4 pt-6 border-t mt-6">
            <button
              type="submit"
              disabled={isLoading}
              className="px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors disabled:opacity-50 flex items-center space-x-2 font-medium"
            >
              {isLoading && <FaSpinner className="animate-spin" />}
              <span>{id ? "Update" : "Save"} </span>
            </button>
            <button
              type="button"
              onClick={onCancel}
              disabled={isLoading}
              className="bg-red-400 hover:bg-red-500 text-white px-6 py-3 border border-gray-300 rounded-lg transition-colors disabled:opacity-50 font-medium"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditApartmentPopup;